import React from "react";

import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import Select from "material-ui/Select/Select";
import MenuItem from "material-ui/Menu/MenuItem";
import CancelRoundedIcon from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/PersonAdd';
import BackupIcon from '@material-ui/icons/Backup';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Pagination from "../Pagination/Pagination";
import GridContainer from "../Grid/GridContainer";
import ItemGrid from "../Grid/ItemGrid";
import SweetAlert from "react-bootstrap-sweetalert";
// import Tooltip from '@material-ui/core/Tooltip';
import '../../assets/css/editabletable.css'
import withStyles from "material-ui/styles/withStyles";
import configurationStyle from "../../assets/jss/material-dashboard-pro-react/layouts/configurationStyle";

import Cookies from "universal-cookie";
import {roseColor} from "../../assets/jss/material-dashboard-pro-react";
import {EXCEL_METADATA_FILENAME} from "../../utils/constants";
import * as FileSaver from 'file-saver';
import * as XLSX      from 'xlsx';
const cookies = new Cookies();


@inject('store')
@observer
class EditableTable extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            projectData:[],
            team: '',
            category:'',
            name:'',
            lastname:'',
            editingEnabled: false,
            startIndex:0,
            finishIndex:50,
            disableBackArrow:false,
            disableForwardArrow:false,
            lastEnabledIndex:1,
            selectedFilter:'Squadra',
            filterStr:'',
            errors: {},
            enableAddRow:false,
            added_team:'',
            added_category:'',
            added_name:'',
            added_lastname:'',
            success_added_athlete_alert: false,
            success_updated_athlete_alert: false,
            success_deleted_athlete_alert: false,
            error_added_athlete_alert: false,
            page:1,
            confirm_delete:false,
            fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            fileExtension: '.xlsx',
            showUploadDataMultiTeam:false,
            errorUploadExcel:false,
            uploadedOK:false,
            rowsPerPage:50
        };

        this.store = this.props.store.appState;
        this.getProjectMetadata = this.getProjectMetadata.bind(this);
    };

    componentWillMount(){
        let self = this;
        if(self.store.sessione_scatti_search_results === false){
            this.getProjectMetadata(true);
        }else{
            this.mapProjectMetadata(this.store.sessione_scatti_search_results);
        }
    }

    componentDidMount() {

    }


    mapProjectMetadata = (res) => {

        let self = this;
        let data = res.map((prop) => {
            return {
                "PhotoID":prop['PhotoID'],
                "teamID":prop['teamID'],
                "categoryID":prop['CategoryID'],
                "Squadra": prop['Squadra'],
                "Categoria": prop['Categoria'],
                "Nome": prop['Nome'],
                "Cognome": prop['Cognome'],
                "Actions":  <div>
                    <EditIcon style={{ color: "#999999", marginRight:"15px" }} />
                </div>
            }
        });
        self.setState({projectData:data, loading:false});
        let flag;
        if(res.length % self.state.rowsPerPage ===0){
            flag = Math.floor(res.length/self.state.rowsPerPage) ;
        } else {
            flag = Math.floor(res.length/self.state.rowsPerPage) + 1;
        }
        self.store.flagPage=flag;
    }

    getProjectMetadata(init=false){
        let self=this;
        const data = {
            project_id: self.store.project_id,
            token: self.store.token
        }
        this.setState({loading:true, itemClicked:false});
        this.store.get_data_sessione_scatti(data, function(res){
            if(res){
                self.mapProjectMetadata(res);
            }else{
                console.log('error');
            }
        });
    }

    enableEdit = (id, /*team, category,*/ name, lastname,teamID,categoryID,photoID) => {
        this.setState({
            rowid: id,
            // team: team,
            // category: category,
            name: name,
            lastname: lastname,
            editingEnabled: true,
            // teamID:teamID,
            // categoryID:categoryID,
            // oldCategory:category,
            oldName:name,
            oldLastname:lastname,
            // oldTeam:team,
            photoID:photoID
        });
    }

    cancelEdit = () => {
        this.setState({editingEnabled:false,errors:{}});

    }

    saveChanges = () => {
        const self = this;

        /// validation for each field to find if it is empty or not
        let errors = {};
        let validData = true;

        // if (self.state.team.length <= 0) {
        //     errors.team = true;
        //     validData = false;
        // }
        // if (self.state.category.length <= 0) {
        //     errors.category = true;
        //     validData = false;
        // }
        if (self.state.name.length <= 0) {
            errors.name = true;
            validData = false;
        }
        if (self.state.lastname.length <= 0) {
            errors.lastname = true;
            validData = false;
        }
        self.setState({
            errors: errors
        })

        if (validData) {

            let modified_data={};
            let finalData = [];

            // modified_data.NuovaSquadra = self.state.team;
            // modified_data.NuovaCategoria = self.state.category;
            modified_data.NuovoNome = self.state.name;
            modified_data.NuovoCognome = self.state.lastname;

            // modified_data.Squadra = self.state.oldTeam;
            // modified_data.Categoria = self.state.oldCategory;
            modified_data.Nome = self.state.oldName;
            modified_data.Cognome = self.state.oldLastname;
            // modified_data.teamID = this.state.teamID;
            // modified_data.categoryID = this.state.categoryID;
            modified_data.photoID = this.state.photoID;

            const pType = self.store.project_type;
            const project_id = self.store.project_id;

            modified_data['project_type'] = pType;
            modified_data['project_id'] = project_id;
            finalData.push(modified_data);

            self.setState({editingEnabled: false,errors:{}});

            self.store.saveModifiedProjectData(finalData, function (result) {
                 // console.log("ADD-ATHLETE-RESPONSE: ", result);
                if (result === true) {
                    self.setState({
                        success_updated_athlete_alert: true
                    })
                    self.getProjectMetadata();

                } else {
                    // console.log('Error during add athlete');
                    self.setState({
                        error_added_athlete_alert: false
                    })
                }
            });
        }

    }

    goToNextPage = () => {
        this.setState({
            startIndex: this.state.startIndex + 50,
            finishIndex: this.state.finishIndex + 50,
            page:this.state.page+1
        });
    }

    goToPreviousPage = () => {
        this.setState({
                startIndex: this.state.startIndex - 50,
                finishIndex: this.state.finishIndex - 50,
                page:this.state.page-1
            }
        );
    }

    closeEditableTable =()=> {
        this.store.showEditableTable = false;
        this.store.modificaDisabled = false;
     }

    selectFilter =(event)=>{
        this.setState({
            selectedFilter:event.target.value
        })
     }

    enableAddRow =()=> {
        this.setState({
            enableAddRow:true
        })
    }

    saveAddedAthlete =()=> {
        const self = this;
        const data_to_be_saved = [];
        let project_type = cookies.get('project_type');

        const added_data = {
            'Categoria': self.state.added_category.trim(),
            'Cognome': self.state.added_lastname.trim(),
            'Nome': self.state.added_name.trim(),
            'Squadra': self.state.added_team.trim(),
            'project_id': self.store.project_id,
            'project_type': project_type
        };
        data_to_be_saved.push(added_data);

        self.store.uploadExcelData(data_to_be_saved, function (result) {
            // console.log("ADD-ATHLETE-RESPONSE: ", result);
            if (result === true) {
                self.setState({
                    success_added_athlete_alert: true
                })
                self.getProjectMetadata();

            } else {
                // console.log('Error during add athlete');
                self.setState({
                    error_added_athlete_alert: false
                })
            }
        });
    }

    handleDeleteAthlete =(team,category,name,lastname,teamID,categoryID,photoID)=> {

       const athlete_to_be_deleted={};
       athlete_to_be_deleted.team=team;
       athlete_to_be_deleted.category=category;
       athlete_to_be_deleted.name=name;
       athlete_to_be_deleted.lastname=lastname;
       athlete_to_be_deleted.teamID=teamID;
       athlete_to_be_deleted.categoryID=categoryID;
       athlete_to_be_deleted.photoID=photoID;
        this.setState({
            confirm_delete:true,
            athlete_to_be_deleted:athlete_to_be_deleted
        })
    }

    deleteConfirmed = () => {
        const self = this;
        self.store.deleteAthlete(self.state.athlete_to_be_deleted, function (res) {
            if (res) {
                self.setState({success_deleted_athlete_alert: true, confirm_delete: false})
            } else {

            }
        });
    }

    closeDeleteModal =()=>{
        this.setState({
            confirm_delete:false
        })
    }

    cancelAddAthlete=()=>{
        this.setState({
            enableAddRow:false
        })
    }

    hideAlert = () => {
        if (this.state.success_added_athlete_alert) {
            this.setState({success_added_athlete_alert: false, enableAddRow: false});
        }

        if (this.state.success_updated_athlete_alert) {
            this.setState({success_updated_athlete_alert: false});
        }

        if (this.state.success_deleted_athlete_alert) {
            this.setState({success_deleted_athlete_alert: false});
            this.getProjectMetadata();
        }

        if (this.state.error_added_athlete_alert) {
            this.setState({error_added_athlete_alert: false, enableAddRow: false});
        }
        if(this.state.showUploadDataMultiTeam){
            this.setState({showUploadDataMultiTeam: false});
            window.location.reload();
        }
        if(this.state.errorUploadExcel){
            this.setState({errorUploadExcel: false});
        }
        this.setState({uploadedOK:false});
        this.getProjectMetadata();
    };

    downloadMetadata =()=> {

        let exportData = [];
        this.store.sessione_scatti_search_results.map((item) => {
            let obj = {
                'PhotoID': item.PhotoID,
                'Squadra': item.Squadra,
                'Categoria': item.Categoria,
                'Nome': item.Nome,
                'Cognome': item.Cognome,
            };
            exportData.push(obj);

            return item;
        });

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = {Sheets: {'data': ws}, SheetNames: ['data']};
        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
        const data = new Blob([excelBuffer], {type: this.state.fileType});

        const d = new Date();
        const currentDayOfMonth = d.getDate();
        const currentMonth = d.getMonth();
        const currentYear = d.getFullYear();
        const dateString = currentDayOfMonth + "-" + (currentMonth + 1) + "-" + currentYear;
        FileSaver.saveAs(data, EXCEL_METADATA_FILENAME +'-'+ dateString + this.state.fileExtension);
    }


    readExcel = (file) => {

        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsArrayBuffer(file);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;
                const wb = XLSX.read(bufferArray, {type: "buffer"});
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                let data = XLSX.utils.sheet_to_json(ws);
                // console.log("BEFORE: ", data);
                data.forEach((item) => {
                    if(item.PhotoID === ""){
                        // console.log("ID FOTO EMPTY");
                        delete item['PhotoID'];
                    }
                });
                data = data.filter((item) => item.PhotoID === undefined);
                // console.log("AFTER: ", data);
                resolve(data);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });

        promise.then((data) => {

            const self = this;
            let unique_teams = [...new Set(data.map(item => item.Squadra))];
            // console.log("UNIQUE-TEAMS: ", unique_teams);

            //===== check project type ======
            let project_type = cookies.get('project_type');
            // console.log(project_type);
            //=== JUST FOR TEST REMOVE IT
            project_type = 'C';

            if(project_type === 'S'){
                // console.log("singolo");
                // console.log(unique_teams.length);
                if(unique_teams.length > 1){
                    self.setState({showUploadDataMultiTeam: true});
                    return;
                }
            }

            // console.log('EXCEL_DATA_BEFORE', data);

            const pType = self.store.project_type;
            const project_id = self.store.project_id;

            // console.log("PROJECT_DATA: ", pType + '-' + project_id);

            data.forEach(item => {
                // const team = item.Squadra.trim().toLowerCase();
                item['project_type'] = pType;
                item['project_id'] = project_id;
            });

            // console.log('EXCEL_DATA_AFTER', data);

            self.setState({ loading:true });

            self.store.uploadExcelData(data, function(res){
                // console.log(res);
                if(res){
                    console.log("upload-data-response", res);
                    self.store.dataUploadedLength = data.length;
                    self.setState({uploadedOK: true, loading: false});
                    self.store.uploadDisabled = true;
                    self.store.modificaDisabled = false;
                    // cookies.set('upload_closed',true);
                }else{
                    self.setState({
                        showEmptyDataError:true,
                        errorUploadExcel:true,
                        loading:false
                    })
                    console.log('error');
                }
            });

            // self.store.dataUploadedLength = data.length;
            // self.setState({uploadedOK: true});
            // self.store.uploadDisabled = true;
            // self.store.modificaDisabled = false;
        });
    };

    render() {

        // const {success_added_athlete_alert, success_updated_athlete_alert, success_deleted_athlete_alert, error_added_athlete_alert, flagPage, page, confirm_delete, projectData, filterStr, selectedFilter,showUploadDataMultiTeam,errorUploadExcel,uploadedOK } = this.state;
        const {success_added_athlete_alert, success_updated_athlete_alert, success_deleted_athlete_alert, error_added_athlete_alert, page, confirm_delete, projectData, filterStr, selectedFilter,showUploadDataMultiTeam,errorUploadExcel,uploadedOK } = this.state;
        
        const filteredData = projectData.filter((e => e[selectedFilter].toLowerCase().includes(filterStr.toLowerCase())));
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        
        let pages = [];
        pages.push({ text: "PREV", onClick:this.goToPreviousPage, disabled:page<=1});
        pages.push({ active: true, text: this.state.page });
        pages.push({ text: "NEXT" , onClick:this.goToNextPage, disabled:page + 1 > this.store.flagPage });


        return (
            <div className="container">
                <div className="table-wrapper">
                    <div className="table-title">
                        <div className="row">
                            <div className="col-sm-8"><h2>Modifica Metadata</h2>
                                <div className='filter-div'>
                                    <div className='tooltip'>
                                        <span className="tooltiptext">Download metadata</span>
                                        <CloudDownloadIcon className='download-icon' onClick={this.downloadMetadata}/>
                                    </div>
                                    <div className='tooltip'>
                                        <span className="tooltiptext">Upload metadata</span>
                                        <input type='file'
                                               id='file-table'
                                               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
                                               onChange={(e) => {
                                            const file = e.target.files[0];
                                            this.readExcel(file);
                                        }}/>
                                        <label htmlFor="file-table"><BackupIcon className='upload-icon'/> </label>
                                    </div>
                                    <div className='tooltip'>
                                        <span className="tooltiptext">Aggiungi atleta</span>
                                        <AddIcon className='add-icon' onClick={this.enableAddRow}/>
                                    </div>
                                    <p>Filtra per :</p>
                                    <Select
                                        style={{fontFamily: 'Roboto', fontStyle: 'normal', fontWeight: "300"}}
                                        fullWidth={false}
                                        disableUnderline={true}
                                        value={this.state.selectedFilter}
                                        onChange={this.selectFilter}
                                        inputProps={{name: "simpleSelect", id: "simple-select"}}>
                                        <MenuItem
                                            value="Squadra"> <span className={'span-lang'}>Squadra </span></MenuItem>
                                        <MenuItem
                                            value="Categoria"><span className={'span-lang'}>Categoria</span></MenuItem>
                                        <MenuItem
                                            value="Nome"><span className={'span-lang'}>Nome </span></MenuItem>
                                        <MenuItem
                                            value="Cognome"><span className={'span-lang'}>Cognome </span></MenuItem>
                                    </Select>

                                    <input className='filter-input' type='text'
                                           onChange={(e) => this.setState({filterStr: e.target.value})}
                                           value={filterStr}/>
                                    <CancelRoundedIcon className='close-icon' onClick={this.closeEditableTable}/>
                                </div>
                            </div>
                        </div>

                    </div>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <th>Squadra</th>
                            <th>Categoria</th>
                            <th>Nome</th>
                            <th>Cognome</th>
                            <th>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.enableAddRow ?
                            <tr className='add-row'>
                                <td><input className='add-row' type ='text' onChange={(event => {
                                    this.setState({
                                        added_team:event.target.value
                                    })
                                })}/></td>
                                <td><input className='add-row' type ='text' onChange={(event => {
                                    this.setState({
                                        added_category:event.target.value
                                    })
                                })}/></td>
                                <td><input className='add-row' type ='text' onChange={(event => {
                                    this.setState({
                                        added_name:event.target.value
                                    })
                                })}/></td>
                                <td><input className='add-row' type ='text' onChange={(event => {
                                    this.setState({
                                        added_lastname:event.target.value
                                    })
                                })}
                                /></td>
                                <td> <div style={{display:'flex',justifyContent: 'space-around'}}>
                                    <CheckIcon style={{
                                    color: '#4caf50',
                                    marginLeft: "10px",
                                    marginRight: '10px',
                                    cursor: 'pointer'
                                }} onClick={this.saveAddedAthlete}/>
                                    <CancelIcon
                                        style={{color: '#e91e63', cursor: 'pointer'}}
                                        onClick={this.cancelAddAthlete}/>
                                </div>
                                </td>
                            </tr>:null }
                        {filteredData.slice(this.state.startIndex,this.state.finishIndex).map((athlete, key) => {
                            // console.log('athlete',athlete)
                            return (
                                <tr key={key}>
                                    <td>
                                        <span>{athlete.Squadra}</span>
                                    </td>
                                    <td>
                                        <span>{athlete.Categoria}</span>
                                    </td>

                                    <td>{this.state.editingEnabled && this.state.rowid === key ?
                                        <input type='text' className={this.state.errors.name && this.state.rowid === key ? 'editable-input-error':'editable-input'} value={this.state.name} onChange={(event) => {
                                            this.setState({name: event.target.value,errors:{}})
                                        }
                                        }/> : <span>{athlete.Nome}</span>}
                                    </td>

                                    <td>{this.state.editingEnabled && this.state.rowid === key ?
                                        <input type='text' className={this.state.errors.lastname && this.state.rowid === key ? 'editable-input-error':'editable-input'} value={this.state.lastname}
                                               onChange={(event) => {
                                                   this.setState({lastname: event.target.value,errors:{}})
                                               }
                                               }/> : <span>{athlete.Cognome}</span>}
                                    </td>

                                      {/*switch from EditMode to SaveMode and CancelMode*/}
                                    {
                                        this.state.editingEnabled === false
                                            ?
                                                <td className='actions' >
                                                    <EditIcon onClick={() => this.enableEdit(key, /*athlete.Squadra, athlete.Categoria,*/  athlete.Nome, athlete.Cognome,athlete.teamID,athlete.categoryID,athlete.PhotoID)} style={{
                                                        display: "block",
                                                        color: '#999999',
                                                        cursor: 'pointer'
                                                    }}/>
                                                    <DeleteIcon onClick={()=>this.handleDeleteAthlete( athlete.Squadra, athlete.Categoria, athlete.Nome, athlete.Cognome, athlete.teamID, athlete.categoryID, athlete.PhotoID)} style={{
                                                        color:roseColor,
                                                       cursor:'pointer'}}/>
                                                </td>
                                                : <td> {this.state.editingEnabled && this.state.rowid === key ?
                                                    <div
                                                        style={{display: 'flex', justifyContent: 'space-around'}}><CheckIcon style={{
                                                        color: '#4caf50',
                                                        marginLeft: "10px",
                                                        marginRight: '10px',
                                                        cursor: 'pointer'
                                                    }} onClick={this.saveChanges}/>

                                                    <CancelIcon
                                                        style={{color: '#e91e63', cursor: 'pointer'}}
                                                        onClick={this.cancelEdit}/></div>
                                                    : <EditIcon style={{
                                                        display: "block",
                                                        margin: "auto",
                                                        color: '#999999',
                                                        cursor: 'pointer'
                                                    }}/>}
                                                </td>
                                    }

                                </tr>
                            )
                        })}

                        </tbody>
                    </table>

                    {
                        success_added_athlete_alert || success_deleted_athlete_alert || success_updated_athlete_alert ?
                            <div>
                                <GridContainer justify={"center"}>
                                    <ItemGrid xs={12} sm={6}>
                                        <SweetAlert
                                            confirmBtnText='Ok'
                                            success
                                            confirmBtnStyle={{background: 'green'}}
                                            style={{fontSize: '8px'}}
                                            title={<div>{ success_added_athlete_alert ?  DEFAULT_TEXT.add_athlete_msg_success_alert : success_deleted_athlete_alert ? DEFAULT_TEXT.delete_athlete_msg_success_alert: success_updated_athlete_alert ? DEFAULT_TEXT.update_athlete_msg_success_alert :''}</div>}
                                            onConfirm={this.hideAlert}
                                            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                        </SweetAlert>
                                    </ItemGrid>
                                </GridContainer>
                            </div>
                            :
                            null
                    }

                    {
                        error_added_athlete_alert ?
                            <div>
                                <GridContainer justify={"center"}>
                                    <ItemGrid xs={12} sm={6}>
                                        <SweetAlert
                                            confirmBtnText='Ok'
                                            warning
                                            confirmBtnStyle={{background: 'green'}}
                                            style={{fontSize: '8px'}}
                                            title={"error during add"}
                                            onConfirm={this.hideAlert}
                                            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                        </SweetAlert>
                                    </ItemGrid>
                                </GridContainer>
                            </div>
                            :
                            null
                    }

                    {
                        confirm_delete
                            ?
                            <SweetAlert
                                warning
                                style={{display: "block", marginLeft: '-188px', marginRop: '-182px'}}
                                title=""
                                onConfirm={this.deleteConfirmed}
                                onCancel={this.closeDeleteModal}
                                confirmBtnCssClass={this.props.classes.button + " " +this.props.classes.success}
                                cancelBtnCssClass={this.props.classes.button + " " + this.props.classes.danger}
                                cancelBtnStyle={{backgroundColor: '#e52d27'}}
                                confirmBtnText={DEFAULT_TEXT.btn_confirm.toUpperCase()}
                                cancelBtnText={DEFAULT_TEXT.btn_cancel.toUpperCase()}
                                showCancel
                            >
                                {DEFAULT_TEXT.delete_row_msg_alert}
                            </SweetAlert>
                            : null
                    }
                    {
                        uploadedOK ?
                            <div>
                                <GridContainer justify={"center"}>
                                    <ItemGrid xs={12} sm={6}>
                                        <SweetAlert
                                            confirmBtnText='Ok'
                                            success
                                            confirmBtnStyle={{background: 'green'}}
                                            style={{fontSize: '8px'}}
                                            title={
                                                 DEFAULT_TEXT.upload_confirm_msg
                                            }
                                            onConfirm={this.hideAlert}
                                            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                        </SweetAlert>
                                    </ItemGrid>
                                </GridContainer>
                            </div>
                            :
                            null
                    }


                    {
                        showUploadDataMultiTeam || errorUploadExcel ?
                            <div>
                                <GridContainer justify={"center"}>
                                    <ItemGrid xs={12} sm={6}>
                                        <SweetAlert
                                            confirmBtnText='Ok'
                                            warning
                                            confirmBtnStyle={{background: 'green'}}
                                            style={{fontSize: '8px'}}
                                            title={
                                                showUploadDataMultiTeam ? DEFAULT_TEXT.config_upload_data_project_type_comune_msg : errorUploadExcel ? "Errore durante excel upload" : ''
                                            }
                                            onConfirm={this.hideAlert}
                                            confirmBtnCssClass={this.props.classes.button + " " + this.props.classes.warning}>
                                        </SweetAlert>
                                    </ItemGrid>
                                </GridContainer>
                            </div>
                            :
                            null
                    }

                    <div className='pagination'>
                        <Pagination pages={pages} color="success" />
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(configurationStyle)(EditableTable);



// WEBPACK FOOTER //
// ./src/components/Table/EditableTable.jsx